// https://explorer.inkonchain.com/address/0x990B75fD1a2345D905a385dBC6e17BEe0Cb2f505
export const CROSS_CHAIN_CONTROLLER = '0x990B75fD1a2345D905a385dBC6e17BEe0Cb2f505';

// IPayloadsControllerCore https://explorer.inkonchain.com/address/0x44D73D7C4b2f98F426Bf8B5e87628d9eE38ef0Cf
export const PAYLOADS_CONTROLLER = '0x44D73D7C4b2f98F426Bf8B5e87628d9eE38ef0Cf';

// https://explorer.inkonchain.com/address/0xd0929668178973d5994D5654929aCB3d6c2b9949
export const PC_DATA_HELPER = '0xd0929668178973d5994D5654929aCB3d6c2b9949';

// https://explorer.inkonchain.com/address/0xa2bDB2335Faf1940c99654c592B1a80618d79Fc9
export const GRANULAR_GUARDIAN = '0xa2bDB2335Faf1940c99654c592B1a80618d79Fc9';

// https://explorer.inkonchain.com/address/0x1bBcC6F0BB563067Ca45450023a13E34fa963Fa9
export const GOVERNANCE_GUARDIAN = '0x1bBcC6F0BB563067Ca45450023a13E34fa963Fa9';

// https://explorer.inkonchain.com/address/0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A
export const EXECUTOR_LVL_1 = '0x47aAdaAE1F05C978E6aBb7568d11B7F6e0FC4d6A';

export const CHAIN_ID = 57073;
